import React from 'react'
import {
  BookkeepingOverview,
  SolopreneurOverview,
} from '@layerfi/components'
import { useOutletContext } from 'react-router-dom'

import { AccountingLayout as BaseAccountingLayout } from '../layouts/AccountingLayout'
import { AccountingOverview } from '../pages/accounting/overview'
import { useSolopreneurInteractionProps } from './solopreneur/solopreneur'

const BookkeepingLayout = () => {
  return (
    <BaseAccountingLayout>
      <BookkeepingOverview />
    </BaseAccountingLayout>
  )
}

const SolopreneurLayout = () => {
  const interactionProps = useSolopreneurInteractionProps()
  return (
    <BaseAccountingLayout>
      <SolopreneurOverview interactionProps={interactionProps} />
    </BaseAccountingLayout>
  )
}

const AccountingLayout = () => {
  return (
    <AccountingOverview />
  )
}

export const LandingPage = () => {
  

  const { isBookkeepingMode, useSolopreneurLayout } = useOutletContext<{
    isBookkeepingMode: boolean
    useSolopreneurLayout?: boolean
  }>()

  const isSolopreneurDemo = useSolopreneurLayout ?? false

  if (isBookkeepingMode) { return <BookkeepingLayout /> }
  if (isSolopreneurDemo) { return <SolopreneurLayout /> }
  return <AccountingLayout />
}
